<template>
  <div>
    <div   
      class="header"
      :class="{ 'header--untouched' : !isTouched }"
    >
      <div class="container">
        <header class="header__section" >
          <h1 class="title">
            <div class="icon">
              <InstagramSVG />
            </div>
            InstaTags
          </h1>
          <h3 class="subtitle">Consiga o melhor desempenho no alcance das suas postagens no Instagram utilizando as melhores hashtags para atrair seu público.</h3>

          <p
            v-if="!hasAccess"
            class="mt-3 text-secondary mb-0"
          >Liberamos uma utilização <strong>limitada</strong> por dia para não assinantes.</p>
        </header>

        <div class="input-area">
          <input
            v-if="hasAccess || hasAccessRemain"
            v-model="query"
            type="search"
            :placeholder="searchPlaceholder"
            @input="debounceInput"
            :readonly="isLoading"
            ref="input"
          />
        </div>
      </div>
    </div>

    <div v-if="isTouched">
      <div class="container"> 
        <div style="position: relative; margin-top: -80px">
          <div v-if="isEmptyResult && hasAccessRemain" style="text-center">
            <p>Ops, não encontramos resultados para esse termo.</p>
          </div>
          
          <div v-if="!hasAccessRemain && !isLoading" class="border-secondary alert text-secondary text-center">
            <p class="mb-3">
              <strong>Ops, você atingiu o seu limite diário de pesquisas gratuitas.</strong>
            </p>

            <SecondaryButton
              @click="$router.push({ name: 'subscribe' })"
            >Quero continuar usando o InstaTags!</SecondaryButton>
          </div>

          <div v-if="!isEmptyResult && !isLoading && hasAccessRemain" class="instructions d-flex justify-content-between align-items-center">
            <h6>Selecione as hashtags que deseja copiar</h6>

            <SecondaryButton
              style="flex: 0 0 auto; padding-right: 16px; padding-left: 16px"
              @click="selectMostUsedHashtags"
            >
              <span v-if="!isBestSelected">Selecionar</span>
              <span v-else>Remover</span>
              melhores
            </SecondaryButton>
          </div>

          <LoadingBox v-if="isLoading" />

          <InstaTagsResults
            v-else-if="hasAccessRemain"
            ref="results"
            :result-set="resultSet"
            :selectTags="selectTags"
            @select="tagSelect"
          />
        </div>
      </div>

      <SelectedHashtag
        v-if="!isFocused"
        :items="selectTags"
        @success="successSelectHashtags"
      />

      <CopiedHashTag ref="success" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import InstagramSVG from '@/components/svg/InstagramSVG'
  import { search } from '@/api/tools/instatags.api'
  import SecondaryButton from '@/components/buttons/SecondaryButton'
  import LoadingBox from '@/components/layout/LoadingBox'
  import InstaTagsResults from '@/components/tools/instatags/InstaTagsResults'
  import SelectedHashtag from '@/components/tools/instatags/SelectedHashtag'
  import CopiedHashTag from '@/components/tools/instatags/CopiedHashTag'
  import _ from 'lodash'

  export default {

    components: {
      LoadingBox,
      InstagramSVG,
      SecondaryButton,
      InstaTagsResults,
      SelectedHashtag,
      CopiedHashTag
    },

    data: () => ({
      isFocused: false,
      queryStr: '',
      resultSet: {},
      isEmptyResult: false,
      isLoading: false,
      isTouched: false,
      accessRemains: true,
      pageWidth: null,
      selectTags: [],
      isBestSelected: false,
    }),

    metaInfo () {
      return {
        title: 'InstaTags - As melhores hashtags para alcançar seu público | CyberClass'
      }
    },

    mounted () {
      window.onresize = () => this.pageWidth = document.body.scrollWidth

      this.$refs.input.addEventListener('focus', () => this.isFocused = true)
      this.$refs.input.addEventListener('blur', () => this.isFocused = false)
    },

    computed: {
      ...mapGetters('user', ['user', 'hasUserSubscriptionAccess']),

      query: {
        set (query) {
          this.queryStr = '#' + query.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\W/g, '')
        },

        get () {
          return this.queryStr
        }
      },

      searchPlaceholder() {
        return this.pageWidth > 992 ? 'Busque uma hashtag, exemplo: #anime' : 'Exemplo: #anime'
      },

      hasAccess () {
        return !!this.user && this.user.has_subscription_access
      },

      hasAccessRemain () {
        return !this.isTouched || this.accessRemains
      },

      resultItems () {
        return (result) => {
          return result.items.length ? result.items : [...Array(10).keys()].map(() => null)
        }
      },

      resultCategories () {
        return Object.keys(this.resultSet)
      },     
    },

    methods: {
      successSelectHashtags () {
        this.$refs.results.reset()
        this.$refs.success.show()
      },

      tagSelect (tags) {
        this.$refs.success.hide()
        this.selectTags = tags       
      },

      debounceInput: _.debounce(function() {
        this.fetchResult(this.query.replace('#', ''))
      }, 1500),

      async fetchResult (query) {
        if (query.length < 3) {
          return null;
        }

        if (this.isTouched) {
          this.$refs.success.hide()
          this.$refs.results.reset()
        }

        this.resultSet = {}
        this.isEmptyResult = false
        this.isLoading = this.isTouched = true

        try {
          this.resultSet = await search(query)
          this.$refs.input.blur()
        } catch (err) {
          if (err.status === 429) {
            this.accessRemains = false
          } else if (err.status === 404) {
            this.isEmptyResult = true
          }
        }

        this.isLoading = false
      },

      selectMostUsedHashtags() {      
        this.isBestSelected = !this.isBestSelected
        this.selectTags = this.resultSet.best_related.slice(0, 30).map(item => item.tag)
        this.selectTags.forEach(tag => this.$refs.results.select(tag))
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .item {
    background: #EBEBEB;
    border-radius: 30px;
    font-size: 0.875rem;
    font-weight: bold;
    color: #737373;

    .item-quantity {
      font-weight: normal;
    }
  }

  .instructions {
    margin-bottom: 24px;
    padding-bottom: 24px;
  }

  .container {
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .header {
    transition: .5s all;

    &--untouched {
      padding-bottom: 100px;
    }

    .input-area {
      margin: 0 auto;
      max-width: 968px;

      input {
        border-radius: 24px;
        padding: 13px 24px;
        border: 0;
        border: 3px solid $yellowBorder;
        background: $white400;
        box-shadow: 0px 4px 8px 2px #12001F, 0px 4px 4px 0px rgba(41, 29, 49, 0.20) inset, 0px 24px 32px -16px rgba(253, 212, 155, 0.25);
      }
    }

    &__section {
      text-align: center;;
      max-width: 750px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2.1875rem;

      .title {
        display: inline-flex;
        align-items: center;
        font-family: $textSecondaryFamily;
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 20px;

        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 60px;
          border-radius: 1.77778rem;
          background: radial-gradient(56.27% 117.62% at 37.5% 100%, rgba(255, 255, 255, 0.29) 0%, rgba(255, 255, 255, 0.05) 100%), radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 11.38%, rgba(91, 0, 105, 0.70) 68.27%), radial-gradient(178.09% 220.16% at 94.89% -132.81%, #9000F0 67.59%, rgba(253, 212, 155, 0.38) 100%);
          border-radius: 100%;
          margin-right: 24px;

          svg { 
            fill: #fff; 
          }
        }
      }

      .subtitle {
        font-family: $textPrimaryFamily;
        font-size: 1rem;
        font-weight: 400;
      }
    }
  }

  .result {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-direction: column;
    gap: 5px;

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 0 0 calc(50% - 5px);
      font-size: 0.89rem;
      padding: 11px 16px;
      border-radius: 36px;
      background: $purple70;
      text-align: left;
    
      &:not(:last-child) { 
        margin-bottom: 16px;
      }

      &__search {
        flex-shrink: 0;

        &__link {
          width: 30px;
          height: 30px;
          border-radius: 100%;
          background: #fff;

          img { width: 60% }

          &:hover {
            background: lighten(#ff8000, 30);
          }

          &:not(:last-child) { margin-right: 5px }
        }
      }

      &__blur &__search {
        display: none;
      }
        
      &__blur {
        span { filter: blur(4px) }
      }

      &:not(&__blur):hover {
        background: lighten(#000, 85);
      }
    }

    @media (max-width: 992px) {
      gap: 0;

      &__item { flex-basis: (100%) }
    }    
  }

.link {
      font-size: 0.9375rem;
      font-weight: 700;
      color: #FF8000;
    }

.btn-copy {
    width: 250px;
		font-weight: bold;
    background: #FF8000;
		color: #FFFFFF;
		height: 40px;
		border: 1px solid #FFFFFF;
		border-radius: 8px;
		cursor: pointer;
}
</style>